var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { shallowEqual } from "react-redux";
import { compareKeys } from "../../helpers/object";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { mergeEntities } from "./mergeEntities";
export var isBookDataUpdated = function (bookDataKey) { return ({
    areStatePropsEqual: function (nextStateProps, prevStateProps) {
        return compareKeys(nextStateProps, prevStateProps, function (x, y, key) {
            switch (key) {
                case bookDataKey:
                    return shallowEqual(x, y);
                default:
                    return Object.is(x, y);
            }
        });
    },
}); };
export var getBookDataResponseManager = function (bookData) {
    var normalizedBookData = bookData.filter(function (x) { return x === null || x === void 0 ? void 0 : x.body; }).map(function (data) { return getResponseManager(data); });
    if (!normalizedBookData.length)
        return undefined;
    var firstBookData = __spreadArray([], normalizedBookData).pop();
    return {
        form_data: firstBookData.formData(),
        pagination: firstBookData.pagination(),
        waitlist_entities: firstBookData.waitlistEntities(),
        entities: mergeEntities(normalizedBookData.map(function (x) { return x.entities(); }))
    };
};
